import {
  Dispatch, SetStateAction, useEffect, CSSProperties,
} from 'react';
import { createPortal } from 'react-dom';
import useKeyPressEvent from 'react-use/lib/useKeyPressEvent';
import { Button } from '../../ui/Button/Button';
import Icon from '../Icon/Icon';
import { IconKeys } from '../Icon/IconKeys';
import S from './ModalStyles';

type Props = {
  children: JSX.Element;
  title: string;
  state: boolean;
  settings?: {
    minHeight?: string,
    minWidth?: string,
    maxHeight?: string,
    maxWidth?: string,
    display?: string,
    flexDirection?: string,
    overflow?: string,
    marginTop?: string,
  };
  toggleState: Dispatch<SetStateAction<boolean>>;
  onClose?: any;
};

function Modal({
  children,
  title,
  state,
  settings,
  toggleState,
  onClose = () => {},
}: Props): JSX.Element {
  const closeModal = (): void => {
    toggleState(false);
    onClose();
  };
  useKeyPressEvent('Escape', () => {
    closeModal();
  });
  useEffect(() => {
    if (state) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [state]);

  return (
    createPortal(
      <S.Wrapper
        isOpen={state}
      >
        <S.ModalContainer
          style={{
            minHeight: settings?.minHeight,
            minWidth: settings?.minWidth,
            maxHeight: settings?.maxHeight,
            maxWidth: settings?.maxWidth,
            display: settings?.display,
            flexDirection: settings?.flexDirection as CSSProperties['flexDirection'],
            overflow: settings?.overflow as CSSProperties['overflow'],
            marginTop: settings?.marginTop,
          }}
          isOpen={state}
        >
          <div className="title-container">
            <h3>{title}</h3>
            <Button onClick={() => closeModal()}>
              <Icon iconKey={IconKeys.CLOSE} />
            </Button>
          </div>
          <div
            className="content-container"
            style={settings?.display === 'flex' ? {
              flex: 1,
              minHeight: 0,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            } : undefined}
          >
            {children}
          </div>
        </S.ModalContainer>
        <S.ModalBackground onClick={() => closeModal()} />
      </S.Wrapper>,
      document.body,
    )
  );
}

export default Modal;
